<script lang="ts">
  import Link from "src/partials/Link.svelte"
  import FlexColumn from "src/partials/FlexColumn.svelte"
  import Card from "src/partials/Card.svelte"
  import Heading from "src/partials/Heading.svelte"

  const XMR = "88yZhiMwHs8FLFZvd78AyRRqQ7kgF4BorXjX3vye8B1nVoMtP2AnNe32rgbsUP2NYPRmFc9vqUsi1ckKmoHX1YGXEezb3FE"
  const LN = "alestrex@cake.cash"
  const TROCADOR = `https://trocador.app/anonpay/?ticker_to=xmr&network_to=Mainnet&donation=true&address=${XMR}`
  const XMRCHAT = "https://xmrchat.com/alestre"

  let xmrCopied = false
  let lnCopied = false

  function copyXmr() {
    navigator.clipboard.writeText(XMR)
    xmrCopied = true
    setTimeout(() => (xmrCopied = false), 2000)
  }

  function copyLn() {
    navigator.clipboard.writeText(LN)
    lnCopied = true
    setTimeout(() => (lnCopied = false), 2000)
  }

  document.title = "About"
</script>

<FlexColumn class="gap-8">
  <div class="flex flex-col items-center justify-center gap-2">
    <Heading>nostr.kommonzenze.de</Heading>
    <p class="text-center text-sm text-neutral-400">
      ein privates, non-profit project von
      <Link external class="underline" href="https://ascend-digital.net">ASCEnD</Link>
    </p>
  </div>
  <div class="grid grid-cols-1 gap-8 sm:grid-cols-2">
    <Card>
      <FlexColumn class="py-6">
        <h3 class="text-xl text-center sm:h-12">Support this service</h3>
        <div class="flex flex-col gap-2">
          <button
            on:click={copyLn}
            class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors text-left">
            <i class="fa fa-bolt text-yellow-400 w-3" />
            {lnCopied ? "Copied!" : "Copy Lightning address"}
          </button>
          <button
            on:click={copyXmr}
            class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors text-left">
            <span class="w-3 text-center font-bold text-xs">Ɱ</span>
            {xmrCopied ? "Copied!" : "Copy XMR address"}
          </button>
          <a
            href={XMRCHAT}
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors">
            <i class="fa fa-comment-dollar w-3" />
            XMR via xmrchat
          </a>
          <a
            href={TROCADOR}
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors">
            <i class="fa fa-coins w-3" />
            Other cryptos
          </a>
        </div>
      </FlexColumn>
    </Card>
    <Card>
      <FlexColumn class="py-6 text-center">
        <h3 class="text-xl sm:h-12">Get in touch</h3>
        <p class="text-sm text-neutral-400">
          We're on Nostr - send a DM or drop a public note.
        </p>
      </FlexColumn>
    </Card>
  </div>
</FlexColumn>
